import * as yup from 'yup';

const schema = yup.object().shape({
    name: yup.string().required('Please provide a Name'),
    colorScheme: yup.string().required('Please select a Color Scheme'),
    logo: yup.string().required('Please select a logo'),
});

export default schema;
